import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from 'recharts';
import { useDarkMode } from '../context/DarkModeContext';

function formatDateTick(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' });
}

function formatDateTooltip(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function HistoricalChart({ data, currentIV, stats, selectedDate }) {
  const { dark } = useDarkMode();

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400 dark:text-gray-500 text-sm">
        Select a symbol to view historical IV chart
      </div>
    );
  }

  const gridColor = dark ? '#374151' : '#e5e7eb';
  const axisColor = dark ? '#6b7280' : '#9ca3af';
  const tooltipStyle = dark
    ? { fontSize: 13, borderRadius: 8, backgroundColor: '#1f2937', border: '1px solid #374151', color: '#f3f4f6' }
    : { fontSize: 13, borderRadius: 8 };

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-3">
        Historical IV ({data.length} data points)
      </h3>
      <ResponsiveContainer width="100%" height={320}>
        <LineChart data={data} margin={{ top: 20, right: 60, bottom: 25, left: 20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateTick}
            tick={{ fontSize: 11, fill: axisColor }}
            stroke={axisColor}
            angle={-30}
            textAnchor="end"
            height={50}
          />
          <YAxis
            tickFormatter={(v) => `${v}%`}
            tick={{ fontSize: 11, fill: axisColor }}
            stroke={axisColor}
            domain={['auto', 'auto']}
            width={50}
          />
          <Tooltip
            formatter={(value) => [`${value.toFixed(2)}%`, 'IV']}
            labelFormatter={formatDateTooltip}
            contentStyle={tooltipStyle}
          />

          {/* Average line */}
          {stats?.avg_iv != null && (
            <ReferenceLine
              y={stats.avg_iv}
              stroke={axisColor}
              strokeDasharray="4 4"
              label={{ value: 'Avg', position: 'right', fontSize: 11, fill: axisColor }}
            />
          )}

          {/* Selected date marker */}
          {selectedDate && (
            <ReferenceLine
              x={selectedDate}
              stroke="#7c3aed"
              strokeDasharray="4 4"
              label={{ value: 'Selected', position: 'top', fontSize: 11, fill: '#7c3aed' }}
            />
          )}

          {/* Current IV line */}
          {currentIV != null && (
            <ReferenceLine
              y={currentIV}
              stroke="#2563eb"
              strokeDasharray="6 3"
              label={{ value: 'Current', position: 'right', fontSize: 11, fill: '#2563eb' }}
            />
          )}

          <Line
            type="monotone"
            dataKey="iv"
            stroke="#3b82f6"
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4, fill: '#2563eb' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
